import { SimpleStatusRequestUpdateSimpleStatusRequestItems, TrainingStatusClient, TrainingStatusResponse } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import store from 'base/reducer/store';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { tryCatchJsonByAction } from 'utils/fetchUtils';

// api

export const getTrainingStatusesAction = () => {
	const tenantId = getTenantId()!;
	const client = new TrainingStatusClient();
	return client.getAll(tenantId);
}

export const updateTrainingStatusesAction = (model: SimpleStatusRequestUpdateSimpleStatusRequestItems) => {
	const tenantId = getTenantId()!;
	const client = new TrainingStatusClient();
	return client.update(tenantId, model);
}

export const persistTrainingCaseStatusesAction = async () => {
	const state = store.getState();

	if (state.persistedTrainingStatus.fetching) {
		return;
	}

	store.dispatch(setFetchingAction(true));

	const response = await tryCatchJsonByAction(getTrainingStatusesAction);
	if (response.success) {
		store.dispatch(setAction(response.items || []));
	} else {
		store.dispatch(setFetchingAction(false));
	}
}

// redux

export const TRAINING_STATUSES_SET = 'TRAINING_STATUSES_SET';
export const TRAINING_STATUSES_FETCHING = 'TRAINING_STATUSES_FETCHING';

const setFetchingAction = (fetching: boolean): FetchingActionType => {
	return {
		type: TRAINING_STATUSES_FETCHING,
		fetching
	}
}

const setAction = (items: TrainingStatusResponse[]): PersistItemsActionType<TrainingStatusResponse> =>  {
	return {
		type: TRAINING_STATUSES_SET,
		items
	}
}
